// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"3b1b6b9f","121":"e19f76df","479":"65db4e3e","849":"e416ddea","881":"dfd9570d"}[chunkId] + ".chunk.js";
};